import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Analytics loads lazily AFTER first paint so posthog-js stays out of the
// initial bundle and never competes with rendering the page. Autocapture
// (pageviews, clicks) starts the moment it initializes.
const posthogKey = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;
if (posthogKey) {
  const loadAnalytics = () =>
    import("posthog-js").then(({ default: posthog }) => {
      posthog.init(posthogKey, {
        api_host: import.meta.env.VITE_POSTHOG_HOST,
        defaults: "2026-01-30",
      });
    });

  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(loadAnalytics, { timeout: 5000 });
  } else {
    window.addEventListener("load", () => window.setTimeout(loadAnalytics, 1500));
  }
}
